import { useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Typography } from '../../components/base';
import Button from '../../components/base/button';
import { CLIENT_ROUTES } from '../../router/routes';
import style from './checkinQuestions.module.scss';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../helpers/hooks/AppContext';
import Rand from 'rand-seed';

const CheckInInstructionsPageCorporate = () => {
  const navigate = useNavigate();
  const onNext = () => {
    navigate(`../${CLIENT_ROUTES.mood_check_in_questionaire}`);
  };
  const theme = useTheme();
  const isTwoColumn = useMediaQuery(theme.breakpoints.up('sm'));



  return (
    <div className={style.questionsPageContainer}>
      <div className={style.questionsPageCenter}>
        <div className={style.questionsPage}>
          <div className={`${style.questionsHeadContainer} ${isTwoColumn ? '' : style.alignJustify}`}>
            <Typography variant="h1">Well-being Pulse survey</Typography>
            <Typography variant="subheading1">
            Your Well-being Pulse survey is a 10-item questionnaire designed to measure how you feel about your emotional well-being, sense of control,  positive relations with others and purpose in life.

            </Typography>
            <div className={style.instructionBox}>
              <Typography variant="h3"> Rate on a scale of 1 to 5              </Typography>
              <div className={style.instructionContent}>
                <ol>
                  <li>
                    <Typography variant="body2">
                      {' '}
                      strongly disagree
                    </Typography>
                  </li>
                  <br />
                  <li>
                    <Typography variant="body2">
                      {' '}
                      disagree
                    </Typography>
                  </li>
                  <br />
                  <li>
                    <Typography variant="body2">
                      {' '}
                      neutral
                    </Typography>
                  </li>
                  <br />
                  <li>
                    <Typography variant="body2">
                      {' '}
                      agree
                    </Typography>
                  </li>
                  <br />
                  <li>
                    <Typography variant="body2">
                      {' '}
                      strongly agree
                    </Typography>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div className={style.spacer} />
          <div style={{ height: '40px' }} />
        </div>
      </div>
      <div className={style.buttonRow}>
        <Button variant="contained" onClick={onNext} >
          Start survey
        </Button>
      </div>
    </div>
  );
};

export default CheckInInstructionsPageCorporate;
